import { createReducer, on } from '@ngrx/store';

import { IFeatureFlag } from '@shared/models/feature-flags';

import {
  resetConfigAction,
  updateOpenModalAction,
  toggleHomeMapViewAction,
  fetchFeatureFlagsAction,
  fetchFeatureFlagsFinishAction,
  hideNoticeAction,
  hidePromoteModalAction,
  setOpenChatWidgetIdAction,
} from './config.actions';

export interface ConfigState {
  openModal?: string;
  openChatWidgetId?: string;
  mapView: boolean;
  featureFlags: {
    fetching: string[];
    items: IFeatureFlag[];
  };
  hiddenNotices: string[];
  hiddenPromoteModals?: string[];
}

export const initialState: ConfigState = {
  openModal: undefined,
  openChatWidgetId: undefined,
  mapView: true,
  featureFlags: {
    fetching: [],
    items: [],
  },
  hiddenNotices: [],
  hiddenPromoteModals: [],
};

export const configReducer = createReducer(
  initialState,
  on(resetConfigAction, () => ({ ...initialState })),
  on(updateOpenModalAction, (state, action) => ({
    ...state,
    openModal: action.openModal,
  })),
  on(toggleHomeMapViewAction, (state) => ({
    ...state,
    mapView: !state.mapView,
  })),
  on(fetchFeatureFlagsAction, (state, action) => ({
    ...state,
    featureFlags: {
      ...state.featureFlags,
      fetching: [...action.keys],
    },
  })),
  on(fetchFeatureFlagsFinishAction, (state, action) => ({
    ...state,
    featureFlags: {
      ...state.featureFlags,
      fetching: [],
      items: [...action.featureFlags],
    },
  })),
  on(hideNoticeAction, (state, action) => ({
    ...state,
    hiddenNotices: [...state.hiddenNotices, action.notice],
  })),
  on(hidePromoteModalAction, (state, action) => ({
    ...state,
    hiddenPromoteModals: [
      ...(state.hiddenPromoteModals || []),
      action.promoteModalSlug,
    ],
  })),
  on(setOpenChatWidgetIdAction, (state, action) => ({
    ...state,
    openChatWidgetId: action.openChatWidgetId,
  }))
);
